import { ReactNode } from 'react'
import { useActiveSubscription } from 'web_core/hooks'
import styles from '~/styles/_pricing.module.scss'
import { PlanCard } from '.'

import { Button, Card } from 'react-bootstrap'
import { FaAngleRight, FaCheckCircle, FaRegBuilding } from 'react-icons/fa'
import { logEvent } from 'web_core/utils'
import { ORGANIZATION_PREMIUM_PLAN_REGISTRATION_URL } from '~/utils'

const BENEFITS: ReactNode[] = [
  '法人、教育機関、その他団体のお客様は代表者がまとめて契約してお得！',
  '研究機関や教育機関の場合は、割引価格で提供！',
]

type Props = {
  maxWidth?: number | 'none'
}

export const OrganizationPlanCard = ({ maxWidth = 'none' }: Props) => (
  <Card
    className={`border-0 mx-auto ${styles['pricing-shadow']}`}
    style={{ maxWidth }}
  >
    <Card.Body className="px-4 py-6">
      <h3 className={`${styles.h3} mb-5`}>
        <FaRegBuilding className="text-primary me-2 align-text-top" />
        法人・教育機関向けのお得なプラン
      </h3>
      <div className="d-flex flex-column flex-md-row justify-content-around align-items-center gap-5 gap-md-7">
        <ul
          className="small mb-0 ps-0"
          style={{
            listStyle: 'none',
            lineHeight: '1.25rem',
          }}
        >
          {BENEFITS.map((BENEFIT, index) => (
            <li className="position-relative ps-5 py-1" key={index}>
              <span
                className="position-absolute start-0 text-center"
                style={{ color: '#2c90d3' }}
              >
                <FaCheckCircle className="align-text-top" />
              </span>
              {BENEFIT}
            </li>
          ))}
        </ul>
        <div className="flex-shrink-0">
          <div className="d-none d-md-block">
            <p className="text-center bf-bold small text-nowrap mb-2">
              ＼ご利用人数に応じてお見積もりします／
            </p>
            <Button
              variant="primary"
              className={`fs-6 w-100 py-2`}
              onClick={() => {
                // 団体プランのお問い合わせしようとした際のイベント収集
                logEvent('tap_pricing_team_inquiry')
                window.open(
                  ORGANIZATION_PREMIUM_PLAN_REGISTRATION_URL,
                  '_blank',
                  'noopener,noreferrer'
                )
              }}
            >
              お問い合わせはこちら
            </Button>
          </div>
          <div className="d-md-none">
            <a
              href={ORGANIZATION_PREMIUM_PLAN_REGISTRATION_URL}
              className="d-flex align-items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              お問い合わせはこちら
              <FaAngleRight />
            </a>
          </div>
        </div>
      </div>
    </Card.Body>
  </Card>
)

export const PlanSection = ({ maxWidth = 'none' }: Props) => {
  const subscription = useActiveSubscription()
  return (
    <section className={`${styles.plan} bg-white`}>
      <h2 className={`${styles.h2} pb-5`}>プラン一覧</h2>
      <div
        className="d-flex flex-column flex-lg-row align-items-stretch align-items-sm-center align-items-lg-stretch justify-content-between gap-6 mx-auto"
        style={{ maxWidth }}
      >
        <PlanCard
          planType="free"
          subscription={subscription}
          className="order-3 order-lg-1"
        />
        <PlanCard
          planType="yearly_paid"
          subscription={subscription}
          className="order-1 order-lg-2"
        />
        <PlanCard
          planType="monthly_paid"
          subscription={subscription}
          className="order-2 order-lg-3"
        />
      </div>
      <div className={styles['py-section']}>
        <OrganizationPlanCard maxWidth={maxWidth} />
      </div>
    </section>
  )
}
